module.exports = __webpack_public_path__ + "media/images/check-8e1c0d3f7cb32a20bbbeb399a6f6df02.svg";